export default {
    // START:: GET APP THEME
    getAppTheme(state) {
        return state.saudi_marche_theme;
    },
    // END:: GET APP THEME GETTER
};
